var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDLink03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1822_17004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66656 8.66666C6.95286 9.04942 7.31813 9.36612 7.73759 9.59529C8.15705 9.82446 8.62089 9.96074 9.09766 9.99489C9.57442 10.029 10.0529 9.96024 10.5008 9.79319C10.9486 9.62613 11.3553 9.36471 11.6932 9.02666L13.6932 7.02666C14.3004 6.39799 14.6364 5.55598 14.6288 4.68199C14.6212 3.808 14.2706 2.97196 13.6526 2.35394C13.0346 1.73591 12.1985 1.38535 11.3246 1.37775C10.4506 1.37016 9.60856 1.70614 8.97989 2.31333L7.83322 3.45333M9.33322 7.33333C9.04692 6.95058 8.68165 6.63388 8.26219 6.4047C7.84273 6.17553 7.37888 6.03925 6.90212 6.00511C6.42536 5.97096 5.94683 6.03975 5.49899 6.20681C5.05115 6.37387 4.64448 6.63528 4.30656 6.97333L2.30656 8.97333C1.69936 9.602 1.36338 10.444 1.37098 11.318C1.37857 12.192 1.72913 13.028 2.34716 13.6461C2.96519 14.2641 3.80123 14.6147 4.67522 14.6222C5.54921 14.6298 6.39121 14.2939 7.01989 13.6867L8.15989 12.5467",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1822_17004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDLink03);
export default __webpack_public_path__ + "static/media/DropD_link-03.a0b4a79afe44a4bdf5554512764747e0.svg";
export { ForwardRef as ReactComponent };